'use strict';

angular.module('supervisorAccessReviewControllers')

.controller('Welcome_SystemToReviewCtrl', ['$scope', '$state', 'authUser', 'accessReview', 'stateAccessReview', 'systemRoleID', 'featureService', function ($scope, $state, authUser, accessReview, stateAccessReview, systemRoleID, featureService) {

    $scope.accessReview = accessReview;
    $scope.systemRoleID = systemRoleID;
    $scope.stateAccessReview = stateAccessReview;

    $scope.showDocumentationLinks = false;
    featureService.hasFeature('DisplayCustomerLogo').then(function (hasFeature) {
        $scope.showDocumentationLinks = hasFeature;
    });

    if (_.isEmpty($scope.accessReview)) {
        $state.go('accessReview.noAccessReview', null, { reload: true });
        return;
    }

    if (stateAccessReview.StateName === 'Submitted' && !$state.is('accessReview.authUser.submitted') && !authUser.IsInAdministrationGroup) {
        $state.go('accessReview.authUser.submitted', null, { reload: true });
        return;
    }
}]);
